import { FormInstance, Input, InputProps } from "antd";
import { FC, useMemo, useState } from "react";
import { onKeyDownNumberWithFixedDecimal } from "src/utils/key-down-validate";

const formatNumberWithCommas = (value: string | number) => {
  if (value === "" || value === null || value === undefined) return "";

  let numStr = String(value).replace(/,/g, ""); // Remove existing commas
  if (isNaN(Number(numStr))) return "";

  let [integerPart, decimalPart] = numStr.split(".");

  // Format integer part with commas
  integerPart = Number(integerPart).toLocaleString("en-US");

  if (decimalPart !== undefined) {
    return `${integerPart}.${decimalPart}`;
  }
  return integerPart;
};

interface MoneyInputProps extends InputProps {
  precision?: number;
  addonAfter?: string;
  formInstance: FormInstance;
  field: string;
}

const MoneyInput: FC<MoneyInputProps> = ({ precision = 4, addonAfter, field, formInstance }) => {
  const formValue = formInstance.getFieldValue(field);

  const setValue = (value: string | number | undefined) => {
    formInstance.setFieldValue(field, value);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target?.value || "";
    let inputValue = val.replace(/,/g, ""); // Remove existing commas

    // Allow only numbers and decimal
    if (!/^\d*\.?\d*$/.test(inputValue)) return;

    setValue(formatNumberWithCommas(inputValue));
  };

  const handleBlur = () => {
    let numValue = formValue ? parseFloat(`${formValue}`.replace(/,/g, "")) : 0; // Remove commas before parsing
    if (!isNaN(numValue)) {
      setValue(numValue.toLocaleString("en-US", { minimumFractionDigits: precision, maximumFractionDigits: precision }));
    } else {
      setValue("");
    }
  };

  return (
    <Input
      value={formValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={(e) => onKeyDownNumberWithFixedDecimal(e, precision)}
      style={{ width: "100%" }}
      {...(addonAfter ? { addonAfter } : {})}
    />
  );
};

export default MoneyInput;
